import { api } from './api';

export interface Category {
  id: string;
  slug: string;
  name: string;
  description?: string | null;
  color?: string | null;
  order: number;
  createdAt: string;
  updatedAt: string;
  _count?: {
    articles: number;
  };
}

export interface CreateCategoryInput {
  name: string;
  slug: string;
  description?: string;
  color?: string;
  order?: number;
}

export interface UpdateCategoryInput {
  name?: string;
  slug?: string;
  description?: string;
  color?: string;
  order?: number;
}

export const categoriesService = {
  // Get all categories
  async getAll(): Promise<Category[]> {
    const response = await api.get('/api/admin/categories');
    return response.data.data;
  },

  // Get single category by ID
  async getById(id: string): Promise<Category> {
    const response = await api.get(`/api/admin/categories/${id}`);
    return response.data.data;
  },

  // Create new category
  async create(data: CreateCategoryInput): Promise<Category> {
    const response = await api.post('/api/admin/categories', data);
    return response.data.data;
  },

  // Update category
  async update(id: string, data: UpdateCategoryInput): Promise<Category> {
    const response = await api.put(`/api/admin/categories/${id}`, data);
    return response.data.data;
  },

  // Delete category
  async delete(id: string): Promise<void> {
    await api.delete(`/api/admin/categories/${id}`);
  },

  // Reorder categories
  async reorder(categories: { id: string; order: number }[]): Promise<void> {
    await api.post('/api/admin/categories/reorder', { categories });
  },
};
